import { useCallback } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { upsertDraft } from 'store/slices/spotDrafts';

export const useAutoSaveDraft = () => {
    const dispatch = useAppDispatch();
    const newSpot = useAppSelector((state) => state.newSpot);

    const save = useCallback((step: 1 | 2 | 3 | 4) => {
        void dispatch(upsertDraft({
            step,
            latitude: newSpot.latitude,
            longitude: newSpot.longitude,
            zoom: newSpot.zoom,
            name: newSpot.name,
            description: newSpot.description,
            selectedCategories: newSpot.selectedCategories,
            selectedHazards: newSpot.selectedHazards,
            pictureIds: newSpot.pictures?.map((p) => p.idFile) ?? [],
            youTubeLink: newSpot.youTubeLink,
            privacy: newSpot.privacy,
            anonymity: newSpot.anonymity,
        }));
    }, [dispatch, newSpot]);

    return { save };
};
